import styled from 'styled-components';

const Error = styled.div`
  font-size: 11px;
  min-height: 16px;
  color: #e00;
`;
// Red, but WCAG compliant shade of reg with a contrast of 4.5: https://www.w3.org/TR/WCAG20-TECHS/G18.html
export default Error;
